@if (organizationId(); as orgId) {
  <app-organization-sidebar-layout>
    <app-page-header>
      <app-page-title>
        {{ 'cockpit.dashboard.page.title' | transloco }}
      </app-page-title>

      <ui-button slot="end" mode="outlined" (click)="consultantCard.onClickCalendar()">
        <ng-icon name="heroCalendar" size="20" class="!block" slot="start" />
        {{ 'cockpit.dashboard.page.consultationAppointment' | transloco }}
      </ui-button>
    </app-page-header>

    @if (isAllLoading()) {
      <app-dashboard-skeleton />
    }

    <div class="@container/main block" [class.hidden]="isAllLoading()">
      <div class="flex flex-col @5xl/main:flex-row gap-5">
        <!-- main -->
        <div class="@container/center flex-1 grid grid-cols-12 gap-5">
          <app-dashboard-parse-request-alert
            class="col-span-12 empty:hidden"
            [organizationId]="orgId"
          />
          <app-dashboard-assistant-card class="inline @5xl/main:hidden col-span-12" />
          <div class="col-span-12 grid grid-cols-1 @2xl/center:grid-cols-2 gap-5 auto-rows-fr">
            <app-dashboard-consumption-summary-card
              [organizationId]="orgId"
              [year]="currentYear()"
            />
            <app-dashboard-cost-summary-card [organizationId]="orgId" [year]="currentYear()" />
          </div>
          <app-dashboard-locations-card
            class="col-span-12 @3xl/center:col-span-4"
            [organizationId]="orgId"
          />
          <app-dashboard-energy-interfaces-card
            class="col-span-12 @3xl/center:col-span-4"
            [organizationId]="orgId"
          />
          <app-dashboard-supplier-contracts-card
            class="col-span-12 @3xl/center:col-span-4"
            [organizationId]="orgId"
          />
          <app-dashboard-hpfc-price-card class="col-span-12" />
        </div>
        <!-- sidebar -->
        <div
          class="flex-none @5xl/main:w-[311px] grid grid-cols-1 md:grid-cols-2 @5xl/main:flex flex-col gap-5"
        >
          <app-dashboard-assistant-card class="hidden @5xl/main:inline" />
          <app-dashboard-consultant-card
            [organizationId]="orgId"
            [initWithOpenContactDialog]="showContactDialog()"
            #consultantCard
          />
          <app-dashboard-help-center-card *appFeatureEnabled="'helpCenter'" />
        </div>
      </div>
    </div>
  </app-organization-sidebar-layout>
}
